import { blockstreamAddressStatsHasTransactions } from '../models/BlockstreamAddressStatsDto';
import { blockstreamRepository } from '../repositories/BlockstreamRepository';
import { getBreezSdk } from './breezSdk';
import { storeUsedOnchainAddress } from './onchainAddressStorage';

async function getBreezOnchainAddress(newAddress: boolean): Promise<string | null> {
  const breezSdk = getBreezSdk();
  if (!breezSdk) {
    return null;
  }

  const response = await breezSdk.receivePayment({
    paymentMethod: { type: 'bitcoinAddress', newAddress },
  });

  const address = response.paymentRequest?.trim();
  return address && address.length > 0 ? address : null;
}

export async function hasOnchainAddressActivity(address: string): Promise<boolean> {
  const normalizedAddress = address.trim();
  if (!normalizedAddress) {
    return false;
  }

  const stats = await blockstreamRepository.getBlockstreamAddressStats(normalizedAddress);
  return blockstreamAddressStatsHasTransactions(stats);
}

export async function resolveOnchainAddress(walletId: string | undefined): Promise<string | null> {
  const currentAddress = await getBreezOnchainAddress(false);
  if (!currentAddress) {
    return null;
  }

  let hasAddressActivity = false;
  try {
    hasAddressActivity = await hasOnchainAddressActivity(currentAddress);
  } catch (error) {
    console.error(`Failed to verify on-chain address activity for ${currentAddress}`, error);
  }

  const normalizedWalletId = walletId?.trim();

  if (normalizedWalletId) {
    storeUsedOnchainAddress(normalizedWalletId, currentAddress);
  }

  if (!hasAddressActivity) {
    return currentAddress;
  }

  return getBreezOnchainAddress(true);
}
